import PropTypes from "prop-types";
import classnames from "classnames";

import "./badge.scss";

const Badge = ({ className, value, variant, ...others }) => {
  const classNamePrefix = "badge";
  const classNames = classnames(
    classNamePrefix,
    `${classNamePrefix}--${variant}`,
    className
  );

  return (
    <span className={classNames} {...others}>
      {value}
    </span>
  );
};

export const badgeVariants = ["primary", "secondary"];

Badge.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.oneOf(badgeVariants),
  className: PropTypes.string,
};

Badge.defaultProps = {
  value: undefined,
  variant: "primary",
  className: undefined,
};

export default Badge;
